import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";

const intelligenceCards = [
  {
    id: "heatmap",
    label: "Portfolio Heatmap",
    description: "IRR vs target, ESG score & risk across all 8 assets",
    route: "/asset-management/portfolio-heatmap",
    icon: "LayoutGrid",
    iconColor: "#7C3AED",
    iconBg: "rgba(124,58,237,0.08)",
    ctaLabel: "View Heatmap",
    stats: [
      { label: "Assets tracked", value: "8" },
      { label: "Above IRR target", value: "5" },
      { label: "Watchlist", value: "2" },
    ],
    accentColor: "#7C3AED",
    accentBg: "rgba(124,58,237,0.06)",
  },
  {
    id: "lifecycle",
    label: "Asset Lifecycle Timeline",
    description: "Acquisition, construction, refinancing & exit windows",
    route: "/asset-management/asset-lifecycle",
    icon: "GitBranch",
    iconColor: "var(--color-primary)",
    iconBg: "rgba(59,76,76,0.12)",
    ctaLabel: "View Timeline",
    stats: [
      { label: "Operational", value: "6" },
      { label: "In construction", value: "2" },
      { label: "Exits in 3yr", value: "1" },
    ],
    accentColor: "var(--color-primary)",
    accentBg: "rgba(59,76,76,0.06)",
  },
  {
    id: "vintage",
    label: "Vintage Year Analysis",
    description: "IRR, MOIC & DPI progression by acquisition cohort",
    route: "/asset-management/vintage-analysis",
    icon: "BarChart2",
    iconColor: "var(--color-success)",
    iconBg: "rgba(5,150,105,0.08)",
    ctaLabel: "View Vintage",
    stats: [
      { label: "Cohorts", value: "7" },
      { label: "Best vintage IRR", value: "14.2%" },
      { label: "Avg MOIC", value: "1.9×" },
    ],
    accentColor: "var(--color-success)",
    accentBg: "rgba(5,150,105,0.06)",
  },
];

export default function PortfolioIntelligenceCards() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2
            className="font-heading font-semibold text-foreground"
            style={{ fontSize: "1rem", lineHeight: 1.4 }}
          >
            Portfolio Intelligence
          </h2>
          <p className="font-caption text-muted-foreground text-xs mt-0.5">
            Deep-dive analytics across the full asset portfolio
          </p>
        </div>
        <button
          onClick={() => navigate("/asset-management/portfolio-heatmap")}
          className="flex items-center gap-1.5 font-caption text-xs font-medium transition-colors hover:opacity-80"
          style={{ color: "var(--color-primary)" }}
        >
          Asset Management
          <Icon name="ArrowRight" size={13} color="var(--color-primary)" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {intelligenceCards?.map((card) => (
          <div
            key={card?.id}
            className="card card-interactive flex flex-col gap-4 hover-lift press-effect transition-all duration-250"
            style={{ padding: "20px 24px" }}
          >
            {/* Header */}
            <div className="flex items-start justify-between gap-3">
              <div
                className="flex items-center justify-center w-10 h-10 rounded-lg flex-shrink-0"
                style={{ background: card?.iconBg }}
              >
                <Icon name={card?.icon} size={20} color={card?.iconColor} strokeWidth={1.8} />
              </div>
              <span
                className="font-caption text-xs font-medium px-2 py-0.5 rounded-full"
                style={{ background: card?.accentBg, color: card?.accentColor }}
              >
                Live
              </span>
            </div>

            {/* Title & description */}
            <div className="flex-1">
              <p
                className="font-heading font-semibold text-foreground mb-1"
                style={{ fontSize: "0.9375rem", lineHeight: 1.35 }}
              >
                {card?.label}
              </p>
              <p className="font-caption text-muted-foreground" style={{ fontSize: "0.78rem", lineHeight: 1.5 }}>
                {card?.description}
              </p>
            </div>

            {/* Mini stats row */}
            <div
              className="grid grid-cols-3 gap-2 rounded-lg py-3 px-2"
              style={{ background: card?.accentBg }}
            >
              {card?.stats?.map((stat) => (
                <div key={stat?.label} className="text-center">
                  <p
                    className="font-heading font-semibold text-foreground"
                    style={{ fontSize: "1rem", lineHeight: 1.2 }}
                  >
                    {stat?.value}
                  </p>
                  <p
                    className="font-caption text-muted-foreground mt-0.5"
                    style={{ fontSize: "0.65rem", lineHeight: 1.3 }}
                  >
                    {stat?.label}
                  </p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <button
              onClick={() => navigate(card?.route)}
              className="flex items-center justify-center gap-2 w-full py-2.5 rounded-lg font-caption text-sm font-medium transition-all duration-150 hover:opacity-90 active:scale-[0.98]"
              style={{
                background: card?.accentBg,
                color: card?.accentColor,
                border: `1px solid ${card?.accentColor}22`,
              }}
            >
              {card?.ctaLabel}
              <Icon name="ArrowRight" size={14} color={card?.accentColor} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
